import { configureStore } from "@reduxjs/toolkit";
//
import authSlice from "./Data/features/authSlice";
import dashboardReducer from "./Data/features/dashboardSlice";
import postReportReducer from "./Data/features/postReportSlice";
import postReducer from "./Data/features/postSlice";
import settingsReducer from "./Data/features/settingsSlice";
import subscriptionReducer from "./Data/features/subscriptionSlice";
import userReducer from "./Data/features/userSlice";
//
import sessionMiddleware from "./Data/middleware/sessionMiddleware";
import { baseApi } from "./Data/services/baseApi";
import { dashboardApi } from "./Data/services/dashboardApi";
import { notificationApi } from "./Data/services/notificationApi";
import { postApi } from "./Data/services/postApi";
import { postReportApi } from "./Data/services/postReportApi";
import { settingApi } from "./Data/services/settingApi";
import { userApi } from "./Data/services/userApi";
import { userAuthApi } from "./Data/services/userAuthApi";
import { SubscriptionApi } from "./Data/services/subscriptionApi";
import { faqApi } from "./Data/services/faqApi";

export const store = configureStore({
  reducer: {
    // RTK Query API
    [baseApi.reducerPath]: baseApi.reducer,
    [SubscriptionApi.reducerPath]: SubscriptionApi.reducer,
    //
    // Local storage Redux
    auth: authSlice,
    dashboard: dashboardReducer,
    setting: settingsReducer,
    user: userReducer,
    subscription: subscriptionReducer,
    posts: postReducer,
    postReport: postReportReducer,
  },
  // load from local storage
  // preloadedState: loadFromLocalStorage(), //todo:

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseApi.middleware,
      SubscriptionApi.middleware,
      sessionMiddleware, // for session check each api response
    ]),
});

//todo:
// function saveToLocalStorage(state) {
//     try {
//         const serialState = JSON.stringify(state)
//         localStorage.setItem("reduxStore", serialState)
//     } catch (e) {
//         console.warn(e);
//     }
// }

//todo:
// function loadFromLocalStorage() {
//     try {
//         const serialisedState = localStorage.getItem("reduxStore");
//         if (serialisedState === null) return undefined;
//         return JSON.parse(serialisedState);
//     } catch (e) {
//         console.warn(e);
//         return undefined;
//     }
// }

//todo:
// store.subscribe(() => saveToLocalStorage(store.getState()));

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
// setupListeners(store.dispatch) //todo:
